<template>
  <div class="about" v-html="html">
    <div class="message_three" style="transform: translateY(10mm);">

      <div class="logos log_btn" style="width: 100%;height: 100%">

        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/a0f46d74c2f74937b6effbb64776de1d" alt="关于我们">

      </div>
    </div>






    <div class="message_three" style="transform: translateY(-20mm);">

      <div class="logos log_btn" style="width: 100%;height: auto">

        <!--标题-->
        <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
          <br/>
          产品与用户体验设计
        </p>

        <!--标题-->
        <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
          <br/>
          工业设计
        </p>

        <!--标题-->
        <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
          <br/>
          结构设计
        </p>
        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          <br/>
          oaim成立于2019年，<br/>
          是一家以用户体验为核心的创新设计机构，我们致力于为企业提供行业整体创新解决方案，帮助企业提高产品竞争力，提升企业品牌价值。<br/>
          oaim design目前提供设计咨询、用户研究、工业设计、结构设计、包装设计、品牌咨询与设计、文创产品开发、网站设计与开发、供应链跟踪等一整套设计服务。<br/>
          oaim design服务于工业自动化、智能硬件、医疗器械、智能大健康、3C、家电等多个行业。<br/>
        </p>

        <!--标题-->
        <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
          <br/>
          品牌设计
        </p>
        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          <br/>
          oaim成立于2019年，<br/>
          是一家以用户体验为核心的创新设计机构，我们致力于为企业提供行业整体创新解决方案，帮助企业提高产品竞争力，提升企业品牌价值。<br/>
          oaim design目前提供设计咨询、用户研究、工业设计、结构设计、包装设计、品牌咨询与设计、文创产品开发、网站设计与开发、供应链跟踪等一整套设计服务。<br/>
          oaim design服务于工业自动化、智能硬件、医疗器械、智能大健康、3C、家电等多个行业。<br/>
        </p>

        <!--标题-->
        <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">
          <br/>
          包装设计
        </p>

        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          <br/>
          oaim成立于2019年，<br/>
          是一家以用户体验为核心的创新设计机构，我们致力于为企业提供行业整体创新解决方案，帮助企业提高产品竞争力，提升企业品牌价值。<br/>
          oaim design目前提供设计咨询、用户研究、工业设计、结构设计、包装设计、品牌咨询与设计、文创产品开发、网站设计与开发、供应链跟踪等一整套设计服务。<br/>
          oaim design服务于工业自动化、智能硬件、医疗器械、智能大健康、3C、家电等多个行业。<br/>
        </p>


      </div>
    </div>


  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "Business",
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    // 设置语言
    this.getMessage()
  },
  methods: {
    getMessage() {
      let that = this
      axios.get('/back/oaimBusiness/business').then(res => {
        let data = res.data.data[0].business
        that.html = data
      })
    }
  }
}
</script>

<style>
.c-body > img {
  width: 100%;
  height: 100%;
}

.message_one {
  margin-left: 16.5%;
  margin-right: 16.5%;
  margin-top: 22mm;
}

.message_one > p {
  /*white-space: pre-wrap;*/
  text-align: left;
  line-height: 12mm;
  font-size: 15px;
}

.message_two {
  margin: 0 16.5%;
}

.logos > p:first-of-type {
  font-size: 15px;
}

.message_two > p:first-of-type {
  /*white-space: pre-wrap;*/
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  margin-top: 22mm;
  margin-bottom: 11.5mm;
  /*background-color: rgb(213,213,213)*/
}

.message_two > p:last-of-type {
  /*border: 1px solid red;*/
  text-align: left;
  /*white-space: pre-wrap;*/
  font-size: 15px;
  line-height: 12mm;
  /*margin-bottom: 35mm;*/
}

.logos > img {
  width: 100%;
  height: auto;
  /*border: 1px solid green;*/
}

.logos > p {
  text-align: left;
}

.message_three {
  margin: 30mm 16.5% 0 16.5%;
  line-height: 12mm;
  /*margin-top: 35mm;*/
}

.message_three > p {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  /*background-color: rgb(213,213,213)*/
}

.p_color {
  color: rgb(80, 80, 80);
  text-align: left;
  word-break: break-word;
}

.p_logo {
  color: rgb(16, 16, 16);
}

.log_btn {
  margin-bottom: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/business/Business.vue